
(function() {
  var result = { translations: { "en-gb": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en-gb": "static-7.935"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.935",
    "ar-eg": "static-7.935",
    "bg": "static-7.935",
    "bn": "static-7.935",
    "ca-es": "static-7.935",
    "cs": "static-7.935",
    "da": "static-7.935",
    "de": "static-7.935",
    "el": "static-7.935",
    "en-gb": "static-7.935",
    "en": "static-7.935",
    "es-mx": "static-7.935",
    "es": "static-7.935",
    "fi": "static-7.935",
    "fr-ca": "static-7.935",
    "fr": "static-7.935",
    "he-il": "static-7.935",
    "hr": "static-7.935",
    "hu": "static-7.935",
    "id": "static-7.935",
    "it": "static-7.935",
    "ja": "static-7.935",
    "ko": "static-7.935",
    "lt": "static-7.935",
    "ms": "static-7.935",
    "nl": "static-7.935",
    "no": "static-7.935",
    "pl": "static-7.935",
    "pt-br": "static-7.935",
    "pt-pt": "static-7.935",
    "ro": "static-7.935",
    "ru": "static-7.935",
    "sk": "static-7.935",
    "sl": "static-7.935",
    "sv": "static-7.935",
    "th": "static-7.935",
    "tl": "static-7.935",
    "tr": "static-7.935",
    "uk": "static-7.935",
    "vi": "static-7.935",
    "x-pseudo": "static-7.935",
    "zh-cn": "static-7.935",
    "zh-hk": "static-7.935",
    "zh-tw": "static-7.935"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en-gb', {version: 'static-7.935'}); }
})();


